if( window.location.hash.length > 1 ){
	window.location.href = window.location.href.replace(`#`, `?module=`);
}

// Func = limiting Scope for this file
var lastScrollTop = 0;
let spaceHeaderCalc = 0;
let heightFooter = 0;
let break_tablet = 1024;
let contactButton = null;
let currentUrl = new URL(window.location);

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function removeEmptyP_Elements(){
	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
}

function getPressElements( moduleToBuildIn, blog_id, tag = 'all' ){
	if( !moduleToBuildIn || !blog_id )
		return false;

	let options = {
		rootMargin: '0px',
		threshold: 0.20,
	}
	let observer = new IntersectionObserver(observerElements, options);

	function observerElements(entries) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('fade-in')
			}
		})
	}

	// tag = encodeURIComponent(tag);
	const FORM_DATA = new FormData();
	FORM_DATA.append('operation', 'getPressElements');
	FORM_DATA.append('blog_id', blog_id);
	FORM_DATA.append('tag', tag)


	fetch(`${site_url}ajax/functions.php`, { method: `POST`, body: FORM_DATA })
	.then( resp => resp.json() )
	.then( data => {
		if( data.err == false ){
			moduleToBuildIn.innerHTML = data.html;

			document.querySelectorAll('.animate-fade').forEach((target) => {
				observer.observe(target);
			});
		}else{
			console.error(`Something went wrong getting the press items \n Message: ${data.err_msg}`);
		}
	})
	.catch( err => {
		console.log(err);
	});
}

function initFilterPress(){
	const ALL_PRESS_MODULE = document.querySelectorAll(`.js-press`);

	ALL_PRESS_MODULE.forEach( pressModule => {
		const FILTER = pressModule.querySelector('.js-press_filter');
		const TO_MOUNT = pressModule.querySelector('.js-press_inner');
		const BLOG_ID = pressModule.dataset.blog_id;

		if( FILTER ){
			let beforeTagActive = null;
			FILTER.addEventListener('click', event => {
				let elementClicked = event.target;
				if( elementClicked.nodeName == 'LI' ){
					if( beforeTagActive ){
						beforeTagActive.classList.remove('active')
					}

					elementClicked.classList.add('active');
					beforeTagActive = elementClicked;

					let tagFromFilter = elementClicked.dataset.tag;
					getPressElements(TO_MOUNT, BLOG_ID, tagFromFilter);
				}
			})

			FILTER.querySelector('li').click();
		}else{
			getPressElements(TO_MOUNT, BLOG_ID);
		}
	} );
}

function manageBurgerMenuMobile(){
	let buttonToOpenBurger = document.querySelectorAll(`.js-openBurgerMenu`);
	let buttonToCloseBurger = document.querySelectorAll(`.js-closeBurgerMenu`);
	let menu = document.querySelector(`.js-burgerNav`);

	const toggleBurger = () => {
		menu.classList.toggle('menuOpened');
		if( menu.classList.contains('menuOpened') )
			document.querySelector(`body`).style.overflow = 'hidden';
		else
			document.querySelector(`body`).removeAttribute('style')
	}

	buttonToOpenBurger.forEach( btnOpen => btnOpen.addEventListener( 'click', toggleBurger ) );
	buttonToCloseBurger.forEach( btnClose => btnClose.addEventListener( 'click', toggleBurger ) );
}

function manageBurgerMenuDesktop(){
	let buttonToOpenBurger = document.querySelectorAll(`.js-openBurgerMenu`);
	let buttonToCloseBurger = document.querySelectorAll(`.js-closeBurgerMenu`);
	let menu = document.querySelector(`.js-burgerNavDesktop`);

	const toggleBurger = () => {
		menu.classList.toggle('menuOpened');
		buttonToOpenBurger.forEach( btnOpen => btnOpen.classList.toggle('menuOpened') );
	}

	buttonToOpenBurger.forEach( btnOpen => btnOpen.addEventListener( 'click', toggleBurger ) );
	buttonToCloseBurger.forEach( btnClose => btnClose.addEventListener( 'click', toggleBurger ) );
}

function manageFrontEndForForms(){
	const inputsHolder = document.querySelectorAll(`.form-module-wrapper .form-module__field`);
	const manageLabelState = ( formElement, clickListener = false ) => {
		let value = formElement.value;
		let label = document.querySelector(`label[for="${formElement.id}"]`);

		if( clickListener ){
			label.classList.add('filled');
		}else{
			if( value == '' || value.length == 0 ){
				label.classList.remove('filled');
			}
		}
	};

	inputsHolder.forEach( holder => {
		let input = holder.querySelector(`input,textarea`);
		let select = holder.querySelector(`select`);

		if( input ){
			input.addEventListener('click', () => {
				manageLabelState( input, true );
			});

			input.addEventListener('blur', () => {
				manageLabelState( input );
			});
		}

		if( select ){
			select.addEventListener('click', () => {
				manageLabelState( select, true );
			});

			select.addEventListener('change', () => {
				manageLabelState( select );
			});
		}
	} );
}

function mountContactButtonOnTouchableDevices(){
	if( !contactButton ){
		contactButton = document.querySelectorAll(`.js-burgerNav a`);
		contactButton = [...contactButton];
		contactButton = contactButton.pop();
	}

	contactButton.remove();
	contactButton.classList.add('contactButton');

	document.querySelector(`.header_right`).innerHTML += contactButton.outerHTML;

	manageBurgerMenuMobile();
}

function scrollFunctionality(){
	currentUrl = new URL(window.location);
	let identifier = currentUrl.searchParams.get('module');

	let sectionFromUrl = document.getElementById(identifier);
	if( sectionFromUrl ){
		const headerOffset = document.querySelector(`header`).getBoundingClientRect().height;
		const elementPosition = sectionFromUrl.getBoundingClientRect().top;
		const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth",
		});
		/*
			* The properties used for the parameter 'block' it's for indicate where the section found should be respect the screen 'start, center, end'
		*/
	};
}

function handlePrintForm(){
	const ALL_FORMS = document.querySelectorAll(`.js-printPDF`);

	ALL_FORMS.forEach( form => {
		form.addEventListener("submit", event => {
			event.preventDefault();

			let principalUrl = form.querySelector('input[name="principal_url"]').value,
				target = form.querySelector('input[name="target"]').value;

			let allActiveCheckBoxs = form.querySelectorAll('input[type="checkbox"]:checked');
			let arryActiveIds = [...allActiveCheckBoxs].map( checkbox => { return checkbox.id; } );
			let stringActiveIds = arryActiveIds.join('|');

			window.open(`${principalUrl}?entries=${stringActiveIds}`, target)

		})
	} );
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	/* 
		? DOM listener just to call functions that need to start after the DOM loads
	*/
	document.addEventListener('DOMContentLoaded', () => {
		removeEmptyP_Elements();
		mountContactButtonOnTouchableDevices();

		if( currentUrl.searchParams.get('module') )
			// setTimeout(() => { scrollFunctionality() }, 1500);

		if( document.querySelector(`.form-module-wrapper `) )
			console.log(`form found to animate field labels`);
		if( document.querySelector(`.form-module-wrapper `) )
			manageFrontEndForForms();

		if( document.querySelector(`.js-press`) )
			initFilterPress();

		if( document.querySelector(`.js-printPDF`) )
			handlePrintForm();
		
		manageBurgerMenuDesktop();
	});
	
	const openVideoBtns = document.querySelectorAll('.js-openVideo');
	if (openVideoBtns.length > 0) {
		openVideoBtns.forEach(btn => {
			btn.addEventListener('click', () => {
				const video = document.getElementById('video');
				if (video && typeof video.play === 'function') {
					video.play();
				}
			});
		});
	}
})();

